import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
const contactMethods = [{
  id: "northern",
  icon: MapPin,
  title: "北部到府團隊",
  value: "新北市淡水區中山路78號",
  link: "https://maps.google.com/?q=台北市中正區忠孝東路一段100號"
}, {
  id: "central",
  icon: MapPin,
  title: "中部到府團隊",
  value: "台中市南屯區黎明路一段1030號",
  link: "https://maps.google.com/?q=台中市西屯區台灣大道三段200號"
}, {
  id: "southern",
  icon: MapPin,
  title: "南部到府團隊",
  value: "台南市北區成功路2段5樓4室",
  link: "https://maps.google.com/?q=高雄市苓雅區四維三路33號"
}];
export default function StartProfessionalCareConversation() {
  return <section data-section-id="73538" id="聯絡資訊" className="w-full py-20 md:py-32 bg-[#fafa] text-foreground">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          
          {}
          <div className="flex flex-col gap-8">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-5xl font-bold text-secondary tracking-tight font-sans">
                聯繫專業聽力團隊
              </h2>
              <div className="space-y-2">
                <p className="text-xl text-muted-foreground leading-relaxed max-w-md font-sans">
                  全台免付費服務專線：
                </p>
                <p className="text-3xl md:text-4xl font-bold text-primary font-sans tracking-wider">
                  0800-555-705
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-6 mt-4">
              {contactMethods.map((method, i) => {
              const Icon = method.icon;
              return <div key={method.id} data-index={i} className="group flex items-start gap-6 p-6 rounded-lg bg-card/80 backdrop-blur-md border border-border shadow-md hover:shadow-lg transition-all duration-300">
                    <div className="flex-shrink-0 w-14 h-14 rounded-full bg-accent flex items-center justify-center text-primary group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-6 h-6" strokeWidth={2} />
                    </div>
                    <div className="flex flex-col gap-1 pt-1">
                      <h3 className="text-[20px] font-bold text-primary font-sans">
                        {method.title}
                      </h3>
                      <Link to={method.link} newTab={true} className="text-[17px] leading-[1.8] font-normal text-foreground hover:text-primary transition-colors font-sans">
                        {method.value}
                      </Link>
                    </div>
                  </div>;
            })}
            </div>
          </div>

          {}
          <div className="w-full h-[500px] lg:h-full min-h-[500px] rounded-3xl overflow-hidden border border-border shadow-2xl relative bg-secondary">
            <iframe title="專業聽力服務據點位置" src="https://www.google.com/maps?q=台北市中正區忠孝東路一段100號&output=embed" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="absolute inset-0 w-full h-full grayscale-[40%] contrast-[1.1] opacity-80 hover:grayscale-0 hover:opacity-100 transition-all duration-700"></iframe>
            
            {}
            <div className="absolute inset-0 pointer-events-none ring-1 ring-inset ring-white/10 rounded-3xl bg-gradient-to-t from-secondary/30 to-transparent"></div>
          </div>

        </div>
      </div>
    </section>;
}